import { z } from "zod";
import {
  MODULE,
  SUB_MODULE,
  CURRICULUM_TOPIC,
  ACADEMIC_YEAR,
  APPLICABLE_GRADES,
  ACTIVITY_TYPE,
  TOPIC_TLM,
  DESCRIPTION,
  KIT_NAME,
  KIT_TYPE
} from "../consts";

export const formValues = z.object({
  [MODULE]: z.string().min(1, "Module is required"),
  [SUB_MODULE]: z.preprocess(
    (val) => (val ? String(val) : undefined),
    z.string().min(1, "This Field is required")
   ),
  [CURRICULUM_TOPIC]: z.string().min(1, "Curriculum Topic is required"),
  [ACADEMIC_YEAR]: z.preprocess(
  (val) => (val ? Number(val) : undefined),
  z.number().min(2020, "Academic Year must be 2020 or later")
 ),
  [APPLICABLE_GRADES]: z
    .array(z.string())
    .min(1, "At least one grade must be selected"),
  [ACTIVITY_TYPE]: z.string().min(1, "Activity Type is required"),
  [TOPIC_TLM]: z.string().min(3, "Topic TLM is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type formValues = z.infer<typeof formValues>;

export const schema = formValues;